import PropTypes from 'prop-types'
import { DateRangePicker as DRP } from '@mui/x-date-pickers-pro'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import Box from '@mui/material/Box'
import Icon from 'components/Icon'
import { useBreakpoints } from 'utils/hooks'
import moment from 'moment/moment'

const DateInputField = ({ InputProps, position, isHotel, ...other }) => (
  <TextField
    InputProps={{
      ...InputProps,
      startAdornment: isHotel ? (
        <InputAdornment position="center">
          <Icon icon={position === 'start' ? 'DepartDate' : 'ReturnDate'} color="secondary" />
        </InputAdornment>
      ) : null,
    }}
    {...other}
  />
)

const DateRangePicker = ({
  outlined,
  round,
  hideNav,
  variant,
  value,
  startText,
  endText,
  isHotel,
  ...props
}) => {
  const { md } = useBreakpoints()
  const controlledValue = [value?.[0] ? moment(value?.[0]) : null, value?.[1] ?  moment(value?.[1]) : null]

  return (
    <Box
      sx={{
        // display: 'contents',
        ...(!outlined && props.error ? {
          '> div': {
            position: 'relative',
            '&:before': {
              border: '2px solid red',
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '6px',
              pointerEvents: 'none',
              zIndex: 1,
            },
          },
        } : {}),
      }}
    >
      <DRP
        className="date-range-picker"
        value={controlledValue}
        sx={theme => ({
          position: 'relative',
          '.MuiInputBase-root': {
            color: variant === 'inverse' ? 'white' : undefined,
          },
          '.MuiMultiInputDateRangeField-separator': {
            ml: 'auto !important',
            mr: 'auto !important',
            width: '1px',
            height: '100%',
            backgroundColor: theme.palette.border.neutralCool_300,
            position: 'absolute',
            left: 0,
            right: 0,
            overflow: 'hidden',
            // display: 'none',
          },
          '> *': {
            m: '0 !important',
          },
        })}
        {...props}
        calendars={md ? 2 : 1}
        slotProps={{
          textField: ({ position }) => ({
            label: undefined,
            variant: outlined ? undefined : 'filled',
            fullWidth: true,
            sx: position === 'start' ? {
              borderRadius: round ? '50px' : '6px',
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              borderRight: 'none',
              '*': {
                borderRight: 'inherit',
                borderRadius: 'inherit !important',
              },
            } : {
              borderRadius: round ? '50px' : '6px',
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderLeft: 'none',
              '*': {
                borderLeft: 'inherit',
                borderRadius: 'inherit !important'
              },
            },
            position,
            isHotel,
            placeholder: position === 'start' ? (isHotel ? 'Check-in' : startText) : (isHotel ? 'Check-out' : endText),
          }),
        }}
        slots={{
          textField: DateInputField,
        }}
      />
    </Box>
  )
}

DateRangePicker.propTypes = {
  hideNav: PropTypes.bool,
  isHotel: PropTypes.bool,
}

DateRangePicker.defaultProps = {
  hideNav: false,
}

export default DateRangePicker
